import { User } from "../../lib/user"
import { getAchievements, TIERED_ACHIEVEMENTS, ALL_ACHIEVEMENTS, Achievement, Tier } from "../../lib/achievements"
import { GameStats } from "../../lib/localStorage"
import Leafs1Img from "../../imgs/achievements/leafs.png"
import Leafs2Img from "../../imgs/achievements/leafs2.png"
import Smoke1Img from "../../imgs/achievements/smoke/smoke1.png"
import Smoke2Img from "../../imgs/achievements/smoke/smoke2.png"
import Smoke3Img from "../../imgs/achievements/smoke/smoke3.png"
import Smoke4Img from "../../imgs/achievements/smoke/smoke4.png"
import Smoke5Img from "../../imgs/achievements/smoke/smoke5.png"
import Smoke6Img from "../../imgs/achievements/smoke/smoke6.png"
import Smoke8Img from "../../imgs/achievements/smoke/smoke8.png"
import Smoke9Img from "../../imgs/achievements/smoke/smoke9.png"
import { Fragment } from "react"

type Props = {
  user: User
}

const TIERS: Tier[] = ["tier-1", "mystery", "tier-2", "tier-3"]
const SMOKES = [
  Smoke1Img,
  Smoke2Img,
  Smoke3Img,
  Smoke4Img,
  Smoke5Img,
  Smoke6Img,
  Smoke8Img,
  Smoke9Img,
]

type TierDetail = {
  divider: string,
  height: string
  grid: string
}

const tierDetails: Map<Tier, TierDetail> = new Map([
  ["tier-1", { divider: Leafs2Img, height: "h-44", grid: "md:grid-cols-4 grid-cols-2" }],
  ["mystery", { divider: Leafs1Img, height: "h-48", grid: "md:grid-cols-3 grid-cols-2" }],
  ["tier-2", { divider: Leafs2Img, height: "h-60", grid: "md:grid-cols-3 grid-cols-2" }],
  ["tier-3", { divider: Leafs1Img, height: "h-96", grid: "md:grid-cols-2 grid-cols-1" }]])

// TODO stats modal doesn't load on this page
export const AchievementsPage = ({
  user,
}: Props) => {
  const stats = user.stats()
  const achievementsEarned = getAchievements(stats).size
  const achievementFragment = (a: Achievement) => {
    const hasAchievement = a.has(stats)
    let description = ""
    if(hasAchievement || a.child?.has(stats) || a.getTier() === "tier-1") {
      description = a.getDescription()
    }

    let img = a.getImg()
    let imgTransform = ""
    let title = a.getTitle()
    if(!hasAchievement) {
      img = SMOKES[Math.floor(Math.random()*SMOKES.length) % SMOKES.length]
      imgTransform = `rotate(${Math.random()*60}deg)`
      title = ""
    }
    const details = tierDetails.get(a.getTier())
    return <>
    {!hasAchievement && <div className="absolute top-0 bottom-0 flex items-center justify-center title text-6xl">?</div>}
    <p className="md:text-2xl md:m-2 title">{title}&nbsp;</p>
    <div className={`flex items-center justify-center ${details!.height}`}>
      <img style={{"transform": imgTransform}} className={a.getStyle()} src={img} alt={a.getTitle()}/>
    </div>
    <div className="md:m-2 title md:text-base text-xs h-10">{description}</div></>
  }

  return <div className="p-4 sm:pb-8 sm:px-6 lg:px-8 flex flex-col grow">
    <div id="container" className="flex grow w-full flex-col items-center">
      <h1 className="title text-4xl md:my-8 my-1 font-bold text-center dark:text-white">Achievements</h1>
      <div className="text-lg dark:text-white">Earned {achievementsEarned}/{ALL_ACHIEVEMENTS.length} ({Math.floor(achievementsEarned * 100 / ALL_ACHIEVEMENTS.length)}%) </div>
      {TIERS.map((k, i) => {
        const details = tierDetails.get(k)
           return <Fragment key={k}>
              <div className="md:my-12 my-2 w-full flex items-center justify-center">
                <img className="md:h-48 h-24" src={details!.divider} alt="leafs" />
              </div>
            <div className={`grid md:gap-2 ${details!.grid}`}>
              {(TIERED_ACHIEVEMENTS.get(k) ?? []).map((a: Achievement, i: number) => <div key={i} className="relative row-span-1 flex flex-col items-center justify-center dark:text-white">
                  {achievementFragment(a)}
                </div>
                )}
              </div>
            </Fragment>

         }
      )}
    </div>
  </div>
}

